export default "__VITE_ASSET__CoCh0FAG__"